import { useMutation } from 'react-query'

import { acceptUmbrellaOrganizationInvitation } from '@modules-deprecated/app/umbrellas/query-api'

import { APIError } from '../../../../../utils'

interface UseAcceptOrganizationInvitationArgs {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useAcceptOrganizationInvitation = ({ onError, onSuccess }: UseAcceptOrganizationInvitationArgs = {}) => {
  const { isLoading: isAccepting, mutate: acceptInvitation } = useMutation(
    (token: string) => acceptUmbrellaOrganizationInvitation(token),
    { onError, onSuccess },
  )

  return {
    acceptInvitation,
    isAccepting,
  }
}
